import { Injectable } from '@angular/core';
import { BehaviorSubject }    from 'rxjs/BehaviorSubject';
import { Storage } from '@ionic/storage';
import { NotificationsProvider } from './notifications';

@Injectable()
export class GlobalProvider {

    logged = new BehaviorSubject<boolean>(false);
    logged$ = this.logged.asObservable();

    unread = new BehaviorSubject<number>(0);
    unread$ = this.unread.asObservable();

    userData = new BehaviorSubject<any>(null);

    constructor (
        private storage: Storage
    ) {}

    isLogged(logged:boolean) {
        this.logged.next(logged);
    }

    updateUserData(userData:any) {
        this.userData.next(userData);
    }

    updateUnread(count: number) {
        this.unread.next(count);
    }

    async getSessionId() {
       return await this.storage.get('user').then(data => {
            if (data != null){
                return data['session_id'];
            }
            return false;
        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/global.ts